export const MenuItems = [
    {
      title : "Home",
      url : "/",
      cName : "nav-links",
      icon : "fa-solid fa-house-chimney"   
    },

    {
      title : "Services",
      url : "/service",
      cName : "nav-links",
      icon :"fa-solid fa-money-bill"
    },
    
    {
      title : "About",
      url : "/about",
      cName : "nav-links",
      icon : "fa-solid fa-circle-info"   
    },

    {
      title : "Contact",
      url : "/contact",
      cName : "nav-links",
      icon : "fa-solid fa-address-book"   
    },

   
      

     

     
]